import { render, staticRenderFns } from "./marketing.vue?vue&type=template&id=4b7bef24&scoped=true"
import script from "./marketing.vue?vue&type=script&lang=js"
export * from "./marketing.vue?vue&type=script&lang=js"
import style0 from "./marketing.vue?vue&type=style&index=0&id=4b7bef24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7bef24",
  null
  
)

export default component.exports